module.exports = __webpack_public_path__ + "img/idhelp.ab5102c3.png";